module.exports = __webpack_public_path__ + "img/banner2_3.852c2ed8.jpg";